module.exports = __webpack_public_path__ + "img/myva_3.10a39fed.png";